import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../../../context/auth-context";
// import { HomeNav } from "../../nav/homeNav";
import { isMobile } from "react-device-detect";
import { Logger, Auth } from "aws-amplify";
import { loginPath, signUpConfirmPath } from "../../main";
import * as yup from "yup";
import { useSmallScreen } from "../../../hooks/useWindowSize";
import { Button } from "../../../tabin/components/button";
import { Input } from "../../../tabin/components/input";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import { Link } from "../../../tabin/components/link";

const logger = new Logger("Sign up");

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const emailSchema = yup.string().email("Please enter a valid email address").required("Please enter an email address");
const firstNameSchema = yup.string().required("Please enter your first name");
const lastNameSchema = yup.string().required("Please enter your last name");
const phoneNumberSchema = yup
    .string()
    // .matches(phoneRegExp, "Please enter a valid phone number")
    .required("Please enter a password");
const passwordSchema = yup.string().min(8, "Password must be at least 8 characters long").required("Please enter a password");

export default () => {
    const { register } = useAuth();
    const [signUpWithEmail, setSignUpWithEmail] = useState(false);
    const { isSmallScreen } = useSmallScreen();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [password, setPassword] = useState("");

    const [serverError, setServerError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [phoneNumberError, setPhoneNumberError] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
        setEmailError("");
        setServerError("");
    };

    const onChangeFirstName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFirstName(event.target.value);
        setFirstNameError("");
        setServerError("");
    };

    const onChangeLastName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLastName(event.target.value);
        setLastNameError("");
        setServerError("");
    };

    const onChangePhoneNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPhoneNumber(event.target.value);
        setPhoneNumberError("");
        setServerError("");
    };

    const onChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
        setPasswordError("");
        setServerError("");
    };
    const onSignUpWithEmail = () => {
        setSignUpWithEmail(true);
    };

    const onSignUp = async () => {
        setLoading(true);
        let fieldsValid = true;

        try {
            await emailSchema.validate(email);
            setEmailError("");
        } catch (e) {
            setEmailError(e.errors[0]);
            fieldsValid = false;
        }

        try {
            await firstNameSchema.validate(firstName);
            setFirstNameError("");
        } catch (e) {
            setFirstNameError(e.errors[0]);
            fieldsValid = false;
        }

        try {
            await lastNameSchema.validate(lastName);
            setLastNameError("");
        } catch (e) {
            setLastNameError(e.errors[0]);
            fieldsValid = false;
        }

        try {
            await phoneNumberSchema.validate(phoneNumber);
            setPhoneNumberError("");
        } catch (e) {
            setPhoneNumberError(e.errors[0]);
            fieldsValid = false;
        }

        try {
            await passwordSchema.validate(password);
            setPasswordError("");
        } catch (e) {
            setPasswordError(e.errors[0]);
            fieldsValid = false;
        }

        if (fieldsValid) {
            try {
                await register(email, password, firstName, "", phoneNumber);
                logger.debug("Successfully logged up");
                setLoading(false);
                navigate(signUpConfirmPath);
            } catch (e) {
                logger.debug("e", e);
                setServerError(e.message);
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onSignUp();
        }
    };

    const onSwitchToLogin = () => {
        navigate(loginPath);
    };
    const emailInput = (
        <>
            <Input name="email" label="Email" type="text" onChange={onChangeEmail} onKeyPress={onKeyPress} value={email} error={emailError} />
        </>
    );

    const firstNameInput = (
        <>
            <Input
                name="firstName"
                label="First Name"
                type="text"
                onChange={onChangeFirstName}
                onKeyPress={onKeyPress}
                value={firstName}
                error={firstNameError}
            />
        </>
    );

    const lastNameInput = (
        <>
            <Input
                name="lastName"
                label="Last Name"
                type="text"
                onChange={onChangeLastName}
                onKeyPress={onKeyPress}
                value={lastName}
                error={lastNameError}
            />
        </>
    );

    const phoneNumberInput = (
        <>
            <Input
                name="phoneNumber"
                label="Phone Number (+64123456789)"
                placeholder="+64123456789"
                type="tel"
                onChange={onChangePhoneNumber}
                onKeyPress={onKeyPress}
                value={phoneNumber}
                error={phoneNumberError}
            />
        </>
    );

    const passwordInput = (
        <>
            <Input
                name="password"
                label="Password"
                type="password"
                onChange={onChangePassword}
                onKeyPress={onKeyPress}
                value={password}
                error={passwordError}
            />
        </>
    );

    const signupButton = (
        <>
            <Button style={{ borderRadius: "8px", width: "100%", height: "52px" }} disabled={loading} onClick={onSignUp} loading={loading}>
                <div className="text-bold">SIGN UP</div>
            </Button>
        </>
    );

    const signUpWithEmailButton = (
        <>
            <Button style={{ borderRadius: "8px", width: "100%", height: "52px" }} onClick={onSignUpWithEmail}>
                <div className="text-bold">SIGN UP WITH EMAIL</div>
            </Button>
        </>
    );

    const alreadyHaveAnAccount = (
        <>
            <div style={{ fontSize: "16px" }}>
                <span className="mr-1">Already have an account?</span>
                <Link onClick={onSwitchToLogin} style={{ margin: "0px 8px" }}>
                    Log in
                </Link>
            </div>
        </>
    );

    const content = (
        <>
            <div
                style={
                    !isSmallScreen
                        ? {
                              padding: "24px",
                              margin: "0 auto",
                              width: "448px",
                              border: "1px solid #e4e4e4",
                          }
                        : {}
                }
            >
                <div className="h2">Sign up</div>
                <div className="mb-4"></div>
                {signUpWithEmail ? (
                    <>
                        {serverError && <div className="text-error mb-3">{serverError}</div>}

                        {emailInput}
                        <div className="mb-2"></div>
                        {firstNameInput}
                        <div className="mb-2"></div>
                        {lastNameInput}
                        <div className="mb-2"></div>
                        {phoneNumberInput}
                        <div className="mb-2"></div>
                        {passwordInput}
                        <div className="mb-3"></div>
                        {signupButton}
                    </>
                ) : (
                    <>{signUpWithEmailButton}</>
                )}
                <div className="separator-3"></div>
                {alreadyHaveAnAccount}
            </div>
        </>
    );

    return (
        <>
            {/* <HomeNav /> */}
            <div
                style={{
                    minHeight: "100vh",
                    maxWidth: "1080px",
                    margin: "auto",
                    padding: "24px",
                    paddingTop: isSmallScreen ? "24px" : "40px",
                    paddingBottom: isMobile ? "80px" : "unset", // for tab nav
                }}
            >
                {content}
            </div>
        </>
    );
};
